import React, { useEffect, useState } from 'react'
import TablaConsolidadoEstados from './TablaConsolidadoEstados'
import Loading from '../../Loading'
import { fechaActual } from '../../../hooks/UseDate'
import { postBuscarPacientesEnUnaProgramacionModificar } from '../../../services/PaginaRuta'

const ConsolidadoEstados = () => {
    const [userDate, setUserDate] = useState([]);
    const [loading, setLoading]=useState(false)
    const searchUserDateApi=(e)=>{

    }

    useEffect(()=>{    
        setLoading(false)
        const body={
          ProFec:fechaActual(),
          ProEmpCod:'1',
          ProSedQr:'001',
          ProCirCod:'',
          MPCedu:''
        }
        postBuscarPacientesEnUnaProgramacionModificar(body).then((res)=>{
          console.log(res.data.error,'dataultiumaaaaa')      
          if(res.data.error){
            setUserDate([])
            setLoading(true)
          }else{         
            setTimeout(() => {          
              setLoading(true)
            }, 3000);        
              setUserDate(Object.values(res.data))        
          } 
        })
      },[])
    
    
    
  return (
    <>
    <div className="">
      <div className=" text-2xl text-[#05a29d] font-medium ">
        Consolidado Cx
      </div>
      
      <div className="flex my-3">
      
          
          </div>

          {/* <div className="text-center bg-[#05a29d]">
        <label
          htmlFor="exampleFormControlInput1"
          className="form-label inline-block mt-1 text-white font-medium px-1 text-xl "
        >
          Filtros de Búsqueda
        </label>
      </div> */}

      <form onSubmit={searchUserDateApi}>
        <div className="flex my-2">
          <div className="mb-3 xl:w-96">
            <label
              htmlFor="exampleFormControlInput1"
              className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
            >
              Número de documento de identidad
            </label>
            <div className="flex">
              <input
                name="userId"
                type="number"
                className="form-control  block w-full  px-3 py-0.5  text-base font-normal
                            text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                            rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                id="exampleFormControlInput1"
                placeholder=""
              />
            </div>
          </div>
          <div className="mb-3 pl-5">
            <label
              htmlFor="exampleFormControlInput1"
              className="form-label inline-block mb-2 text-gray-900 font-medium"
            >
              Fecha
            </label>
            <div className="flex">
              <div className="flex items-center justify-center">
                <div className="datepicker relative form-floating mb-3 xl:w-96">
                  <input
                    defaultValue={fechaActual()}
                    type="date"
                    name="date"
                    className="form-control block w-full px-3 py-0.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    placeholder="Select a date"
                  />
                </div>
              </div>

              <div className="px-3">
                <button
                  type="submit"
                  className="inline-block px-6 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                >
                  Buscar
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
      
      <div className="flex flex-col">
            <div className="overflow-x-auto md:overflow-x-visible sm:overflow-x-visible">
                <div className="py-2 inline-block min-w-full">
                <div className="overflow-auto md:overflow-visible">
                    <table className="min-w-full text-center bg-gray-200">
                <thead className=" ">
                  <tr>
                  <th></th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2 "
                    >
                      Estado
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2 bg-gray-200"
                    >
                      Modificar
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2 bg-gray-200"
                    >
                      Agregar Paquetes Qx
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2 bg-gray-200"
                    >
                      Consentimiento Informado
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2 bg-gray-200"
                    >
                      N° Cirugía
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2 bg-gray-200"
                    >
                      Tipo Documento
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2 bg-gray-200"
                    >
                      N° documento
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2 bg-gray-200"
                    >
                      Nombre
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2 bg-gray-200"
                    >
                      Fecha
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2 bg-gray-200"
                    >
                      Procedimiento
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2 bg-gray-200"
                    >
                      Hora Inicio
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2 bg-gray-200"
                    >
                      Hora Final
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2 bg-gray-200"
                    >
                      Teléfono
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2 bg-gray-200"
                    >
                      Quirófano
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2 "
                    >
                      Edad
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2 "
                    >
                      Cod Contrato
                    </th>
                    
                  </tr>
                </thead>
                
                  {loading?
                  userDate.map((item, index) => (
                    <TablaConsolidadoEstados user={item} key={index} />
                  )):
                  <tbody>
                  <tr className="divide-y divide-slate-700 ">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td><Loading/></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  </tbody>
                }
                
              </table>
            </div>
          </div>
        </div>
      </div>
      




    </div>
    {/* {modalOnProgramacionDeCirugia? <ModalProgramacionDeUnaCirugiaN setmodalOnProgramacionDeCirugia={setmodalOnProgramacionDeCirugia} passDataActualizaTablaPacientes={passDataActualizaTablaPacientes}/>:null} */}
    {/* {modalOnImprimirProgramacion? <ImprimirProgramacion setmodalOnImprimirProgramacion={setmodalOnImprimirProgramacion}/>:null} */}
    {/* {modalOnConsentimientoInformado? <ModalConsentimientoInformado setmodalOnConsentimientoInformado={setmodalOnConsentimientoInformado}/>:null} */}
  </>
  )
}

export default ConsolidadoEstados